import { render, staticRenderFns } from "./editBind.vue?vue&type=template&id=9b11dd18&scoped=true"
import script from "./editBind.vue?vue&type=script&lang=js"
export * from "./editBind.vue?vue&type=script&lang=js"
import style0 from "./editBind.vue?vue&type=style&index=0&id=9b11dd18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b11dd18",
  null
  
)

export default component.exports